export type TileSelectType = "radio" | "checkbox";
